export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.49.29a.938.938 0 01-.03 1.326L3.277 6.562h12.504a6.719 6.719 0 110 13.438h-3.594a.937.937 0 110-1.875h3.594a4.844 4.844 0 100-9.688H3.277l5.183 4.947a.937.937 0 11-1.295 1.357L.29 8.178a.938.938 0 010-1.356L7.165.259A.938.938 0 018.491.29z\"/>",
  "attrs": {
    "viewBox": "0 0 23 20",
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};